import { render, staticRenderFns } from "./GymRating-Edit.vue?vue&type=template&id=4dc99030&"
import script from "./GymRating-Edit.js?vue&type=script&lang=js&"
export * from "./GymRating-Edit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports